import React from 'react';
import Section from '@hero/ui-kit/layout/Section';
import H from '@hero/ui-kit/typography/H';
import { PaymentUpdateParams } from '@hero/hero-types';
import useRTMTransfer from '../../../../Membership/api/useRTMTransfer';
import InlineLoader from '../../../../../components/InlineLoader';
import { StripeForm, StripeWrapper } from '../../../../../components/Stripe';
import QueryInlineError from '../../../../../components/QueryInlineError';
import { useTransferToD2C } from '../context/TransferToD2CContext';

const CollectPayment: React.FC = () => {
    const { onCreditCardSuccess, selectedPlan, selectedMitigation, heroUserId } =
        useTransferToD2C();
    const { mutateAsync, isPending, isError, error } = useRTMTransfer();

    const onSubmit = (formValues: PaymentUpdateParams) => {
        const attributes = {
            ...formValues,
            hero_user_id: heroUserId,
            ...(selectedMitigation && {
                months: selectedMitigation.months,
                discount_type: selectedMitigation.discount_type,
                mitigation_type: selectedMitigation.mitigation_type
            }),
            ...(selectedPlan && {
                plan: selectedPlan
            })
        };

        mutateAsync(attributes)
            .then(() => onCreditCardSuccess())
            .catch((backendError) => {
                console.error('Backend API error during RTM transfer:', backendError);
            });
    };

    return isPending ? (
        <InlineLoader />
    ) : (
        <Section noDefaultPadding centered>
            <H role="h6">Collect Payment Method</H>
            <StripeWrapper>
                <StripeForm onSubmit={onSubmit} isSubmitDisabled={isPending} />
            </StripeWrapper>
            {isError ? <QueryInlineError error={error} /> : null}
        </Section>
    );
};

export default CollectPayment;
